import { render, staticRenderFns } from "./employeeStatement.vue?vue&type=template&id=71bc1e6a&scoped=true"
import script from "./employeeStatement.vue?vue&type=script&lang=js"
export * from "./employeeStatement.vue?vue&type=script&lang=js"
import style0 from "./employeeStatement.vue?vue&type=style&index=0&id=71bc1e6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bc1e6a",
  null
  
)

export default component.exports